export default {
  getters: {
    departments: () => [],
  },
  actions: {
    resetEntryDelay() {},
    toggleWidgetModal() {},
  },
};
